// The server returns the resolved role policy plus individual overrides.
export const staffPages = {
  StaffCities: 'cities', StaffLocations: 'locations',
  StaffOrganizations: 'organizations', StaffUsersManagement: 'users',
  StaffMedical: 'medical', StaffPatients: 'patients', StaffSpecializations: 'specializations',
  StaffOrganizationRoles: 'organization_roles', StaffHealthTrackers: 'health_trackers',
  StaffVisitReasons: 'visit_reasons', StaffCancellationReasons: 'cancellation_reasons',
  StaffSupport: 'support', StaffSupportChat: 'support', StaffSurveys: 'survey_list',
  SurveyBuilder: 'surveys', SurveyEdit: 'surveys', SurveyStatistics: 'survey_results',
  PsychologicalRiskDashboard: 'psychological_monitoring', StaffLogging: 'logging',
  StaffOrgReports: 'org_reports'
}

export const staffPaths = {
  locations: '/staff/locations', cities: '/staff/cities',
  organizations: '/staff/organizations', users: '/staff/users', medical: '/staff/medical-staff',
  patients: '/staff/patients', specializations: '/staff/specializations',
  organization_roles: '/staff/organization-roles', health_trackers: '/staff/health-trackers',
  visit_reasons: '/staff/visit-reasons', cancellation_reasons: '/staff/cancellation-reasons',
  support: '/staff/support', surveys: '/staff/surveys', survey_results: '/staff/surveys',
  psychological_monitoring: '/staff/psychological-monitoring', logging: '/staff/logging',
  org_reports: '/staff/org-reports'
}

export const staffTabs = {
  users: ['medical', 'organization', 'patients', 'personnel'],
  logging: ['dashboard', 'activities', 'doctors', 'psychologists', 'patients', 'laboratoryStats',
    'report2', 'report3', 'indicators', 'attachedDoctors', 'schoolDoctors'],
  org_reports: ['appointments', 'indicators', 'schoolDoctors'],
  survey_results: ['statistics', 'responses']
}

export function canStaffAccess(user, key) {
  if (user?.is_superuser) return true
  if (!user?.is_staff) return false
  if (key === 'survey_list') return canStaffAccess(user, 'surveys') || canStaffAccess(user, 'survey_results')
  const parent = key.split('.')[0]
  return user.staff_access?.[parent] === true && user.staff_access?.[key] === true
}

export function canStaffTab(user, page, tab) {
  return (staffTabs[page] || []).includes(tab) && canStaffAccess(user, `${page}.${tab}`)
}

export function canOpenStaffPage(user, page) {
  // The superuser uses the main reports section; organization reports retain
  // their existing entry point for directors and observers.
  if (user?.is_superuser && page === 'org_reports') return false
  return canStaffAccess(user, page)
}

export function firstStaffTab(user, page) {
  return (staffTabs[page] || []).find(tab => canStaffAccess(user, `${page}.${tab}`)) || null
}

export function staffLanding(user) {
  if (user?.is_superuser) return '/staff/locations'
  if (user?.staff_role === 'correctional_admin') return '/correctional'
  if (user?.staff_role === 'clinic_manager') return '/clinic-today'
  const page = Object.keys(staffPaths).find(key => canOpenStaffPage(user, key))
  return page ? staffPaths[page] : '/staff/no-access'
}
